// ─────────────────────────────────────────────────────────────
// ZIFEK — TVA conditionnelle
// La TVA n'est appliquée QUE si le marchand a renseigné son numéro
// d'inscription à la taxe professionnelle (users.tva). Sans ce numéro,
// le marchand n'est pas assujetti : aucun montant de TVA ne s'affiche.
// ─────────────────────────────────────────────────────────────

/** Taux de TVA appliqué (20 % par défaut, modèle marocain). */
export const VAT_RATE = 0.2;

/**
 * Le marchand est-il assujetti à la TVA ?
 * Vrai uniquement si le numéro d'inscription à la taxe est renseigné.
 */
export function chargesVat(tva: string | null | undefined): boolean {
  return Boolean(tva && String(tva).trim());
}

/** Montant de TVA (0 si le marchand n'est pas assujetti). */
export function computeVat(
  subtotal: number,
  tva: string | null | undefined,
  rate: number = VAT_RATE,
): number {
  if (!chargesVat(tva)) return 0;
  return subtotal * rate;
}